import React from "react";
import { useDispatch } from "react-redux";

import type { Message } from "../../utils/types";
import ConversationHistoryDropdown from "./ConversationHistoryDropdown";
import { closeAIChat } from "src/redux/ai-chat/aiChatActions";
import { ReactComponent as CloseIcon } from "src/images/cross-alt.svg";
import { ReactComponent as PlusIcon } from "src/images/plus-dark-grey.svg";
import { ReactComponent as ExpandIcon } from "src/images/move-to-the-left.svg";
import { ReactComponent as CondenseIcon } from "src/images/move-to-the-right.svg";

interface ChatToolbarProps {
  onConversationLoad: (
    conversationId: number,
    messages: Message[],
    isArchived?: boolean,
  ) => void;
  onLoadingConversation: (isLoading: boolean) => void;
  onClearConversation: () => void;
  getCurrentConversationId: () => number | null;
  selectedConversationId: number | null;
  setSelectedConversationId: React.Dispatch<
    React.SetStateAction<number | null>
  >;
  isWide: boolean;
  onToggleWide: () => void;
}

export default function ChatToolbar({
  onConversationLoad,
  onLoadingConversation,
  onClearConversation,
  getCurrentConversationId,
  selectedConversationId,
  setSelectedConversationId,
  isWide,
  onToggleWide,
}: ChatToolbarProps) {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(closeAIChat());
  };

  return (
    <div className="ai-chat__toolbar">
      <div className="ai-chat__toolbar-left">
        <ConversationHistoryDropdown
          onConversationLoad={onConversationLoad}
          onLoadingConversation={onLoadingConversation}
          selectedConversationId={selectedConversationId}
          setSelectedConversationId={setSelectedConversationId}
          getCurrentConversationId={getCurrentConversationId}
        />
        <PlusIcon className="ai-chat__icon" onClick={onClearConversation} />
      </div>
      <div className="ai-chat__toolbar-right">
        <button
          type="button"
          className="ai-chat__icon-button"
          onClick={onToggleWide}
          title={isWide ? "Condense AI Assistant" : "Expand AI Assistant"}
          aria-label={isWide ? "Condense AI Assistant" : "Expand AI Assistant"}
        >
          {isWide ? (
            <CondenseIcon className="ai-chat__icon" />
          ) : (
            <ExpandIcon className="ai-chat__icon" />
          )}
        </button>
        <button
          type="button"
          className="ai-chat__icon-button"
          onClick={handleClose}
          title="Close AI Assistant"
          aria-label="Close AI Assistant"
        >
          <CloseIcon className="ai-chat__icon" />
        </button>
      </div>
    </div>
  );
}
